import { jsx } from "react/jsx-runtime";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { validateTidalLicense } from "../../base/index.js";
function WifiOff(props) {
  return /* @__PURE__ */ jsx(
    WifiOffIcon,
    {
      "data-testid": "WifiOff",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "WifiOff",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
WifiOff.tidalIconMeta = {
  categories: "devices,photos",
  name: "WifiOff"
};
validateTidalLicense();
export {
  WifiOff
};
//# sourceMappingURL=WifiOff.js.map
